import { Component, Input } from '@angular/core';
import { FormArray } from '@angular/forms';
import { PIIQuestionFormGroup } from '@modules/login-shared/types/pii-question-form-group.type';

@Component({
    selector: 'app-login-enter-pii',
    templateUrl: './login-enter-pii.component.html',
    styleUrls: ['./login-enter-pii.component.scss']
})
export class LoginEnterPIIComponent {
    @Input()
    public formArray!: FormArray<PIIQuestionFormGroup>;
}
